import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const FeeConfigurationLazy = React.lazy(
	() => import(/* webpackChunkName : 'FeeConfiguration' */ './components')
);

export default (store) => [
	{
		path: 'fee-configuration',
		element: <AsyncLoading component={<FeeConfigurationLazy />} />,
	},
];
